import { defineMessages } from 'react-intl';

export default defineMessages({
    requests: {
        id: 'csm-requests-header-link.requests',
        defaultMessage: 'Requests',
        description: 'Link to the requests list page',
    },
});
